import type { Configuration } from '@azure/msal-browser'
import { PublicClientApplication } from '@azure/msal-browser'

const config: Configuration = {
  auth: {
    clientId: 'a8581991-dc2c-40ec-b42b-b8c0428c3e68',
    authority:
      'https://vouchauth.b2clogin.com/vouchauth.onmicrosoft.com/B2C_1_sign_up_sign_in',
    knownAuthorities: ['vouchauth.b2clogin.com'],
    redirectUri: '/',
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri:
      import.meta.env.MODE === 'development'
        ? 'http://localhost:3000'
        : 'https://vouchauth.b2clogin.com/vouchauth.onmicrosoft.com/B2C_1_sign_up_sign_in/oauth2/v2.0/logout?post_logout_redirect_uri=https://agent.vouch.co.uk',
  },
  cache: {
    storeAuthStateInCookie: true,
    cacheLocation: 'localStorage',
  },
  system: {
    iframeHashTimeout: 10000,
  },
}

export const msalInstance = new PublicClientApplication(config)
